import { render, staticRenderFns } from "./CustomTablePagination.vue?vue&type=template&id=9146ada4&scoped=true"
import script from "./CustomTablePagination.vue?vue&type=script&lang=ts"
export * from "./CustomTablePagination.vue?vue&type=script&lang=ts"
import style0 from "./CustomTablePagination.vue?vue&type=style&index=0&id=9146ada4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9146ada4",
  null
  
)

export default component.exports